import VOPSProfileDialog from './VOPSProfileDialog';

export default VOPSProfileDialog;
